export const getCookie = (name) => {
  const match = document.cookie.match(new RegExp("(^| )" + name + "=([^;]+)"));
  if (match) return match[2];
  else return null;
};

export const removeCookie = (name) => {
  document.cookie = `${name}=; domain=.asanmuraciet.gov.az; path=/; expires = Thu, 01 Jan 1970 00:00:00 GMT`;
};

export const removeRequestCookie = (name) => {
  document.cookie = `${name}=; domain=localhost; path=/; expires = Thu, 01 Jan 1970 00:00:00 GMT`;
}